import { Route, useLocation, Routes } from 'react-router-dom'
import Principal from './Components/principal'
import { useEffect } from 'react'
import Question from './Components/Information/question'
import Identification from './Components/Information/identification'
import { AnimatePresence } from "framer-motion"
import PageNotFound from './Components/pagenotfound'
import Complete from './Components/Information/complete'
import 'react-toastify/dist/ReactToastify.css';
import Terms from './Components/Information/terms'
import Career from './Components/Information/Career'
import configData from "./config.json"
import StudentInfo from './Components/Information/studentInfo'



export default function App() {
  useEffect(() => {
    // Importing files depending on time of the day
    import(`./App_${configData.COMPANY}.css`)
    import(`./index_${configData.COMPANY}.css`)

    document.getElementById('widget-chattigo').setAttribute('title', configData.CHAT)
  }, []);

  const location = useLocation()
  return (
    <div className="App container-fluid p-0">
      <nav className="navbar navbar-light bg-1 p-0">
        <div className="container">
          <a className="navbar-brand" href="#">
            <img src={`/01-logo-${configData.COMPANY}.png`} alt="" height="75" />
          </a>
        </div>
      </nav>
      <div className=''>
        <AnimatePresence>
          <Routes>
            <Route path="/" element={<Principal />} />
            <Route path="/Information" element={<Question />} />
            <Route path="/information/identify" element={<Identification />} />
            <Route path="/information/complete" element={<Complete />} />
            <Route path="/information/terms" element={<Terms />} />
            <Route path="/information/career" element={<Career />} />
            <Route path="/information/resume" element={<StudentInfo />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </AnimatePresence>
      </div>
      <footer className="container-fluid border-top footer card-footer bg-black text-center">
        <div className="row pt-5">
          <div className="col-sm-12 text-center txtU mt-2">
            {configData.UniversityText}
          </div>
        </div>
        <div className="row">
          <div className="col-12 justify-content-md-center bold" id="socialNetwork">
            <p className="bold">
              <a href={configData.SOCIAL_NETWORKS.FB} target="_blank">
                <img src="/icon-FB_online.png" className='img-fluid icon' />
              </a>
              <a href={configData.SOCIAL_NETWORKS.INSTAGRAM} target="_blank">
                <img src="/icon-instagram_online.png" className='img-fluid icon' />
              </a>
              <a href={configData.SOCIAL_NETWORKS.TWITTER} target="_blank">
                <img src="/icon-twitter_online.png" className='img-fluid icon' />
              </a>
              <a href={configData.SOCIAL_NETWORKS.YOUTUBE} target="_blank">
                <img src="/icon-yt_online.png" className='img-fluid icon' />
              </a>
              <a href={configData.SOCIAL_NETWORKS.LINKEDIN} target="_blank">
                <img src="/icon-linkedin_online.png" className='img-fluid icon' />
              </a>
            </p>
          </div>
        </div>
      </footer>     
    </div>
  );
}